import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RescheduleParams } from "../../../domain/entities/supervisor-delivery";
import { type SupervisorDeliveryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reschedule = createAsyncThunk<
  void,
  RescheduleParams,
  { dispatch: SupervisorDeliveryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RESCHEDULE, async (params, { extra }) => {
  await extra.supervisorDeliveryRepo.reschedule(params);
});
